/** True on iOS, iPadOS, and macOS Safari — platforms where fixed inner scroll breaks. */
export function isIosTouchScrollDevice(): boolean {
  const ua = navigator.userAgent;
  return (
    ua.indexOf('Mac') !== -1 ||
    ua.indexOf('iPhone') !== -1 ||
    ua.indexOf('iPad') !== -1
  );
}
